// extracted by mini-css-extract-plugin
export default {"container":"style_container__v+cfj","header":"style_header__0TSA6","noToggle":"style_noToggle__CmZq9","title":"style_title__NTHFt","errorText":"style_errorText__NVvCg"};